import axios from 'axios';

export default async function confirmEmail(code: string) {
  const URL = `${process.env.REACT_APP_API_URL}/api/auth/email-confirmation?confirmation=${code}`;
  const response = await axios.get(URL);
  return response.data;
}
